import ProductCard from "./ProductCard";
import AnimateOnScroll from "../AnimateOnScroll";
import type { Product } from "@/lib/shop";

interface ProductGridProps {
  products: Product[];
}

const ProductGrid = ({ products }: ProductGridProps) => {
  return (
    <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
      {products.map((product, i) => (
        <AnimateOnScroll
          key={product.id}
          animation="animate-scale-in"
          delay={`delay-${Math.min((i + 1) * 100, 600)}`}
        >
          <ProductCard product={product} />
        </AnimateOnScroll>
      ))}
    </div>
  );
};

export default ProductGrid;
